//   const operators = ['+', '#', '.', '/', ';', '?', '&']
export enum Operator {
  NONE = '',
  PLUS = '+',
  HASH = '#',
  DOT = '.',
  SLASH = '/',
  SEMI = ';',
  QUESTION = '?',
  AMP = '&',
}
